import ProjectCard from './ProjectCard';

function Projects({projects}) {
  return (
    <section className="projects" id="projects" aria-labelledby="projects-heading">
      <div className="section-heading">
        <p className="eyebrow">Selected work</p>
        <h2 id="projects-heading">Projects</h2>
      </div>
      <div className="project-grid">
        {projects.map((project, index) => (
          <ProjectCard key={project.id} project={project} index={index} />
        ))}
      </div>
    </section>
  );
}

export default Projects;